import { Component, OnInit, ViewChild } from '@angular/core';
import { ExcelService } from './excel.service';
import { VillageStaffService } from './village-staff.service';



@Component({
  selector: 'app-village-staff',
  templateUrl: './village-staff.component.html',
  styleUrls: ['./village-staff.component.scss']
})
export class VillageStaffComponent implements OnInit {
  public columnNames = {
    id: 'plate No.',
    reason: 'reason',
    createdAt: 'Date'
  };
  public selectedTab: any;
  public reasons;

  constructor(private excelService: ExcelService, private villageStaffService: VillageStaffService) {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    }
  }

  ngOnInit(): void {
  }


  selectTab(e) {
    this.selectedTab = e;
  }




}
